module.exports = __webpack_public_path__ + "img/AyudaBuscarEvento.b1980cbf.png";